import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'grid', 'content', 'empty']

  declare readonly inputTarget: HTMLInputElement
  declare readonly gridTargets: HTMLElement[]
  declare readonly contentTargets: HTMLElement[]
  declare readonly emptyTargets: HTMLElement[]

  connect (): void {
    this.inputTarget.value = ''
    this.filter()
  }

  filter (): void {
    const query = this.inputTarget.value.trim().toLowerCase()
    let totalVisibleSections = 0

    this.gridTargets.forEach((grid) => {
      const items = grid.querySelectorAll<HTMLElement>('[data-ui-name]')
      let visibleCount = 0

      items.forEach((item) => {
        const name = item.dataset.uiName ?? ''
        const match = name.includes(query)
        item.classList.toggle('hidden', !match)
        if (match) visibleCount++
      })

      const content = grid.closest('[data-ui-search-target="content"]')
      if (content !== null) {
        const shouldHide = visibleCount === 0 && query !== ''
        content.classList.toggle('hidden', shouldHide)
        if (!shouldHide) totalVisibleSections++
      }
    })

    const globalEmpty = this.emptyTargets.at(-1)
    if (globalEmpty !== undefined && globalEmpty !== null) {
      globalEmpty.classList.toggle('hidden', totalVisibleSections > 0)
    }
  }
}
